module.exports = "../dist/img/product-detail-4-18.78bc.jpg";